<template>
   <el-card class="box-card dashboard-card">
      <div slot="header" class="clearfix">
         <span><b>Disponibilidade</b>: Marque os dias em que você <b class="text-secondary">NÃO QUER DISPONIBILIZAR</b> a sua bicicleta.</span>
      </div>
      <!-- Calendar for selecting availability dates | Calendário para a seleção de datas de disponibilidade  -->
      <b-row class="buttons-shortcut-calendar">
         <b-col cols="12" sm="3" class="mb-3 mb-sm-0">
            <el-button
               @click="() => !options.isDisableSundays
                  ? disableDates(0)
                  : removeDaysOfWeek(bikeForm.info.availableDates, 0)"
               size="mini"
               :type="options.isDisableSundays ? 'danger' : 'gost'"
               :round="false"
               :plain="options.isDisableSundays"
               class="w-100">
               <span v-if="options.isDisableSundays"><i class="el-icon-check" /> Alugar nos Domingos</span>
               <span v-else><i class="el-icon-close" /> Não alugar nos Domingos</span>
            </el-button>
         </b-col>
         <b-col cols="12" sm="3" class="mb-3 mb-sm-0">
            <el-button
               @click="() => !options.isDisableSaturdays
                  ? disableDates(6)
                  : removeDaysOfWeek(bikeForm.info.availableDates, 6)"
               size="mini"
               :type="options.isDisableSaturdays ? 'danger' : 'gost'"
               :round="false"
               :plain="options.isDisableSaturdays"
               class="w-100">
               <span v-if="options.isDisableSaturdays"><i class="el-icon-check" /> Alugar nos Sábados</span>
               <span v-else><i class="el-icon-close" /> Não alugar nos Sábados</span>
            </el-button>
         </b-col>
         <b-col cols="12" sm="3" class="mb-3 mb-sm-0">
            <el-button
               @click="() => !options.isDisableBrazilianHolidays
                  ? dasableBrazilianHolidays(this.generateDatesUpToXYears(), this.generateDatesUpToXYears(1), this.generateDatesUpToXYears(2), this.generateDatesUpToXYears(3))
                  : removeDisasabledBrazilianHolidays(this.generateDatesUpToXYears(), this.generateDatesUpToXYears(1), this.generateDatesUpToXYears(2), this.generateDatesUpToXYears(3))"
               size="mini"
               :plain="options.isDisableBrazilianHolidays"
               :type="options.isDisableBrazilianHolidays ? 'danger' : 'gost'"
               :round="false"
               class="w-100">
               <span v-if="options.isDisableBrazilianHolidays"><i class="el-icon-check" /> Alugar nos Feriados</span>
               <span v-else><i class="el-icon-close" /> Não alugar nos Feriados</span>
            </el-button>
         </b-col>
         <b-col cols="12" sm="3" class="mb-3 mb-sm-0">
            <el-button
               @click="() => !options.isDisableDaysOfTheWeek
                  ? disableDates(1,2,3,4,5)
                  : removeDaysOfWeek(bikeForm.info.availableDates, 1,2,3,4,5)"
               size="mini"
               :plain="options.isDisableDaysOfTheWeek"
               :type="options.isDisableDaysOfTheWeek ? 'danger' : 'gost'"
               :round="false"
               class="w-100">
               <span v-if="options.isDisableDaysOfTheWeek"><i class="el-icon-check" /> Alugar nos Dias de Samana</span>
               <span v-else><i class="el-icon-close" /> Não alugar Dias de Samana</span>
            </el-button>
         </b-col>

      </b-row>
      <hr class="mb-0">
      <el-calendar
         v-loading="updateCalendar"
         id="available_dates_calendar__dashboard"
         class="available-dates-calendar__dashboard"
         :class="{stopNextMonthSelection}"
         ref="calendar"
      >
         <template
            slot="dateCell"
            slot-scope="{date, data}"
            class="data.day"
         >

            <el-popover
               class="info-day"
               v-if="rentedDates.dates.includes(data.day)"
               placement="top-start"
               :title="setStatus(book(data.day).status)"
               width="200"
               trigger="hover"
            >
                <span :data="setStatus(book(data.day))">
                   <ul class="list-unstyled">
                       <li>Pedido Nº: {{ book(data.day).orderN }}</li>
                       <li>Ciclista: {{
                             book(data.day).customer.firstName
                          }} {{ book(data.day).customer.lastName }}</li>
                       <li>Bicicleta: {{ book(data.day).bike.name }}</li>
                   </ul>
                </span>
               <el-button slot="reference"></el-button>
            </el-popover>

            <span
               :title="rentedDates.dates.includes(data.day) ? setStatus(book(data.day).status) : ''"
               class="dayBlock" @click="getDayOfCalendar(data)"
               :class="
                        [
                            bikeForm.info.availableDates.includes(data.day) ? 'is-available' : '',
                            rentedDates.dates.includes(data.day) ? 'rented status ' + statusColor(book(data.day).status) : '',
                        ]
                        ">
                        {{ data.day.split('-').slice(2).join() }}

                  <i v-if="bikeForm.info.availableDates.includes(data.day)" class="el-icon-close" />
                  <i v-if="!bikeForm.info.availableDates.includes(data.day)" class="el-icon-check" />
                        {{
                  bikeForm.info.availableDates.includes(data.day) &&
                  !rentedDates.dates.includes(data.day) ?
                     '' : null
               }}

                        <span v-if="rentedDates.dates.includes(data.day)" class="rented-info">

                           <span v-if="rentedDates.dates.includes(data.day)" class="rented-info">
                            #{{ book(data.day).orderN }} |
                            {{
                                 book(data.day).customer.firstName
                              }} {{ book(data.day).customer.lastName }}
                        </span>

                        </span>
                  </span>
         </template>
      </el-calendar>

      <b-row class="mt-3">
         <b-col v-if="this.bikeId" cols="12" md="3" class="text-center mb-3 mb-md-0">
            <!-- Salvar  -->
            <el-button
               @click="bikeId ? saveAvailableDates() : dialogAvailableDates = false"
               :loading="bikeFormStates.submit.loading"
               :round="true"
               type="primary"
               class="w-100 text-uppercase font-weight-bold">
               Salvar
            </el-button>
         </b-col>

         <b-col cols="12" md="4" class="text-center mb-3 mb-md-0">

            <!-- Próximo -->
            <el-button
               @click="() =>  this.$emit('goTo', 'caracteristicas')"
               :round="true"
               :type="this.bikeId ? 'blue' : 'primary'"
               :plain="!!this.bikeId"
               class="w-100 text-uppercase font-weight-bold">
               {{ this.bikeId ? 'Editar Características →' : 'Próximo →' }}
            </el-button>

         </b-col>

         <!-- Cancelar -->
         <b-col cols="12" md="3" class="text-center mb-3 mb-md-0">
            <el-button
               @click="() =>  this.$emit('goTo', 'info')"
               type="default"
               :round="true"
               class="w-100 text-uppercase font-weight-bold">Voltar
            </el-button>
         </b-col>

         <b-col cols="12" md="2" class="text-center">
            <el-button
               @click="() =>  this.$router.push('/painel/anunciante/minhas-bicicletas')"
               type="default"
               :round="true"
               class="w-100 text-uppercase font-weight-bold">Sair
            </el-button>
         </b-col>

         <b-col   v-if="false" cols="12" md="5" class="text-center">
            <el-button
               @click="clearAllDates()"
               type="danger"
               :round="true"
               plain
               size="mini"
               slot="reference"
               class="w-100"
            >
               <v-icon name="calendar-times" scale="0.8" style="margin-top: -4px; margin-right: 3px"/>
               Limpar Datas
            </el-button>
         </b-col>

      </b-row>
   </el-card>
</template>

<script>
import {setStatus, statusColor} from '@/helpers/status'
import bikeForm from '@/models/Bike';
import BikeService from '@/services/bike.service';

export default {
   name: 'SelectAvailableDatesCalendar',
   props: {
      bikeForm: {
         type: Object,
         default: bikeForm
      },
      bikeId: {
         type: String,
         default: ''
      },
      dialogAvailableDates: {
         type: Boolean,
         default: false
      }
   },
   data() {
      return {
         updateCalendar: false,
         stopNextMonthSelection: false,
         rentedDates: {
            orderInfo: [],
            dates: [],
         },
         bikeFormStates: {
            submit: {
               loading: false
            },
            cancel: {
               loading: false
            }
         },
         statusColor,
         setStatus,
         loading: false,
         helpModal: {
            open: false,
            title: '',
            desc: '',
            top: '15vh',
            width: '30%'
         },
         holidaysBrazil: [
            "01/01",
            "02/20",
            "02/21",
            "02/22",
            "04/07",
            "04/09",
            "04/21",
            "05/01",
            "06/08",
            "09/07",
            "10/12",
            "11/02",
            "11/15",
            "12/24",
            "12/25",
            "12/31",
         ],
         options: {
            isDisableSundays: false,
            isDisableSaturdays: false,
            isDisableDaysOfTheWeek: false,
            isDisableBrazilianHolidays: false
         },
      }

   },
   mounted() {
      this.handleOptions()
   },
   methods: {
      getYearMonthFromCalendar() {
         const titleCalendar = document.querySelector('.el-calendar__title');

         if (titleCalendar) {
            return titleCalendar.textContent.trim().split("  ");
         }
      },

      closeModalCalendar() {
         this.$emit('closeModal', false);
        /* this.$confirm('Tem certeza que deseja sair desta janela?')
            .then(() => {
               this.$emit('closeModal', false);
               done();
            })
            .catch(() => {
            });*/
      },

      book(data) {
         return this.rentedObjTemp.find(element => element[this._r(data)])[this._r(data)]
      },

      // Métodos para lidar com o calendário
      getDayOfCalendar(obj) {
         this.updateCalendar = true

         const selectedDay = obj.day; //Obtem, pelo onclick, o dia selecionado.

         const alreadySelected = this.bikeForm.info.availableDates.includes(selectedDay)

         if (alreadySelected) {
            this.bikeForm.info.availableDates = this.bikeForm.info.availableDates.filter(f => f !== selectedDay)
         } else {
            this.bikeForm.info.availableDates.push(selectedDay);
         }

         this.updateCalendar = false
      },

      saveAvailableDates() {
         // Usado para ordenar e remover datas duplicadas.
         const dates = this.bikeForm.info.availableDates.sort()
         const handleUnicDates = [...new Set(dates)];

         this.loading = true;
         BikeService.updateAvailableDates(this.bikeId, handleUnicDates, this.options)
            .then((response) => {
               this.bikeFormStates.submit.loading = false;
               this.dialogAvailableDates = false
               this.loading = false;
               this.$alert(response.data.message, 'Datas de disponibilidade atualizadas!', {
                  confirmButtonText: 'OK',
                  cancelButtonText: 'Continuar editando',
                  closeOnClickModal: false,
                  showClose: false,
                  showCancelButton: true,
                  callback: (v) => {
                     this.loading = false;
                     if (v === 'confirm')
                        this.$router.push(`/painel/anunciante/minhas-bicicletas`);
                  }
               });
               // this.$router.push(`/painel/anunciante/minhas-bicicletas`);

            })
            .catch(err => {
               this.$message.error(err.response.data.message);
               this.bikeFormStates.submit.loading = false;
               this.dialogAvailableDates = false
               this.loading = false;
            });
      },

      selectAllDaysOfSelectedMonth() {
         let arrAavailableDates = this.bikeForm.info.availableDates;
         let arrDays = [];

         const date = new Date();

         //Usado para transformar o mês obtido do calendário em numero do mês
         const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
            "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
         ];

         //Pega o ano e mês do calendário, com base no título dele (tratado via getYearMonthFromCalendar())
         const yearCalendar = this.getYearMonthFromCalendar()[0];
         const monthCalendar = monthNames.indexOf(this.getYearMonthFromCalendar()[1]);

         //Verifica se o ano e mês atual são iguais ao do calendário, se não, o for usa o ano e mês do calendário
         const currentYear = yearCalendar === date.getFullYear() ? date.getFullYear() : yearCalendar;
         const currentMonth = monthCalendar === date.getMonth() ? date.getMonth() : monthCalendar;

         //Obtem o número total de dias do mês atual
         const totalDaysOfCurrentMonth = new Date(currentYear, currentMonth + 1, 0).getDate();


         //Cria os dias com base no mês selecionado
         const createDaysBasedOnCurrentMonth = (currentMonth, currentYear) => {

            const arr = [];
            for (let i = 0; i < totalDaysOfCurrentMonth; i++) {

               //Usado para formatar a data de acordo com a leitura da string usada no calendário, no caso 'YYYY-MM-DD'
               const formatedDay = currentYear + '-' + ("0" + (currentMonth + 1)).slice(-2) + '-' + ("0" + (i + 1)).slice(-2);
               arrDays.push(formatedDay);
            }
            return arr;
         };

         //Armazena os dias do mês que foram criados em createDaysBasedOnCurrentMonth()
         arrDays = arrDays.concat(createDaysBasedOnCurrentMonth(currentMonth, currentYear));


         //Elimina da arrAavailableDates qualquer data que seja igual a qualquer data do mês selecionado
         // Isso é usado para limpar qualquer seleção feita manualmente no calendário
         const deleteDatesOfCurrentMonthFromArray = (datesArr, daysOfMonth) => {

            let conter = 0;

            for (let i = 0; i < daysOfMonth.length; i++) {
               const existingDay = datesArr.indexOf(daysOfMonth[i]) > -1;
               const index = datesArr.indexOf(daysOfMonth[i]);

               //Se qualquer dia do mês atual contiver na array, ele será eliminado.
               if (existingDay) {
                  conter++;
                  datesArr.splice(index, 1);
               }
            }
            //Usado para determinar se todos os dias do mês foram preenchidos
            // Se o counter for igual ao numero de dias do mês atual...
            return conter === totalDaysOfCurrentMonth;
         };


         if (deleteDatesOfCurrentMonthFromArray(arrAavailableDates, arrDays)) {
            // Primeiro ele limpa
            deleteDatesOfCurrentMonthFromArray(arrAavailableDates, arrDays)
         } else {
            //depois limpa e adiciona
            deleteDatesOfCurrentMonthFromArray(arrAavailableDates, arrDays);
            this.bikeForm.info.availableDates = arrAavailableDates.concat(arrDays);
         }
      },

      // Usado para determinar se o usuário escolheu Remover todas as datas com base no atalho.
      checkDayOfWeek(state, ...dayOfWeek) {
         for (const day of dayOfWeek) {
            switch (day) {
               case 0:
                  this.options.isDisableSundays = state;
                  break;
               case 6:
                  this.options.isDisableSaturdays = state;
                  break;
               default:
                  this.options.isDisableDaysOfTheWeek = state;
            }
         }
      },

      // Obtém uma lista de datas com base no dia da semana. Ex: todos os domingos do ano.
      getDaysArray(startYear, endYear, ...dayOfWeek) {
         let days = [];
         for (let year = startYear; year <= endYear; year++) {
            for (let month = 0; month < 12; month++) {
               for (let day = 0; day < 31; day++) {
                  let date = new Date(year, month, day);
                  if (dayOfWeek.includes(date.getUTCDay())) {
                     let formattedDate =
                        year +
                        "-" +
                        ("0" + (date.getMonth() + 1)).slice(-2) +
                        "-" +
                        ("0" + date.getDate()).slice(-2);
                     days.push(formattedDate);
                  }
               }
            }
         }
         return days;
      },

      // Retorna o Ano atual ou ano atual + X anos.
      generateDatesUpToXYears(x){
         return x ? new Date().getFullYear() + x : new Date().getFullYear()
      },

      // Desativa as datas com base no atalho: Todos os domingos, todos os sábados, etc, do ano atual e mais 2 anos.
      disableDates(...dayOfWeek) {
         const actualDates = [...new Set(this.bikeForm.info.availableDates)];
         const arrDays = this.getDaysArray(this.generateDatesUpToXYears(), this.generateDatesUpToXYears(3), ...dayOfWeek)
         this.bikeForm.info.availableDates = [...new Set(arrDays), ...actualDates]
         this.checkDayOfWeek(true, ...dayOfWeek)
      },

      // Remove a seleção de datas desativadas com base no atalho (caso esteja selecionado).
      removeDaysOfWeek(dates, ...dayOfWeek) {
         const actualDates = [...new Set(this.bikeForm.info.availableDates)];
         this.bikeForm.info.availableDates = actualDates.filter(date => !dayOfWeek.includes(new Date(date).getUTCDay()));
         this.checkDayOfWeek(false, ...dayOfWeek)
      },

      // Formata as datas dos feriados e cria uma lista para X anos.
      formatDateHolidays(...years){
         const holidays = this.holidaysBrazil;
         let formattedHolidays = [];
         years.forEach(year => {
            const holiday = holidays.map(holiday => {
               const date = new Date(`${year}-${holiday}`);
               return date.getFullYear() +
                  "-" +
                  ("0" + (date.getMonth() + 1)).slice(-2) +
                  "-" +
                  ("0" + date.getDate()).slice(-2);
            });
            formattedHolidays.push(...holiday);
         });
         return formattedHolidays
      },

      // Desativa os feriádos navionais.
      dasableBrazilianHolidays(...years) {
         const actualDates = [...new Set(this.bikeForm.info.availableDates)];
         this.bikeForm.info.availableDates = [...new Set(this.formatDateHolidays(...years)), ...actualDates]
         this.options.isDisableBrazilianHolidays = true
      },

      // // Remove a seleção de datas desativadas com base no atalho de feriádos navionais
      removeDisasabledBrazilianHolidays(...years) {
         const actualDates = [...new Set(this.bikeForm.info.availableDates)];
         const datesToRemoveSet = new Set(this.formatDateHolidays(...years))
         const availableDatesSet = new Set(actualDates);

         this.bikeForm.info.availableDates = [...availableDatesSet].filter(
            date => !datesToRemoveSet.has(date)
         )
         this.options.isDisableBrazilianHolidays = false
      },

      clearAllDates() {
         this.$confirm('Isso limpara todas datas de todos os meses. Está certo disso?', 'Atenção', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancelar',
            type: 'warning'
         }).then(() => {
            this.bikeForm.info.availableDates = [];
         }).catch(() => {
         });
      },

      changeOptions(key, state) {
         this.$emit('dataCalendar', {key, state});
      },

      handleOptions() {
         this.options = this.bikeForm.info.options
      }
   },
   watch: {
      'options.isDisableSundays': function (e) {
         this.changeOptions('isDisableSundays', e)
      },
      'options.isDisableSaturdays': function (e) {
         this.changeOptions('isDisableSaturdays', e)
      },
      'options.isDisableDaysOfTheWeek': function (e) {
         this.changeOptions('isDisableDaysOfTheWeek', e)
      },
      'options.isDisableBrazilianHolidays': function (e) {
         this.changeOptions('isDisableBrazilianHolidays', e)
      },
      'bikeForm': function () {
         this.handleOptions()
      }
   }
}
</script>

<style>
/* component styles */
</style>
